import styled from 'styled-components';

export const ErrorPageOuterWrapDiv = styled.div(
  props => `
  width: 70vw;
  display:flex;
  justify-content: space-between;
  align-items: center;
`,
);

export const ErrorPageLeftWrapper = styled.div(
  props => `
  
    // display:flex;
  
  `,
);

export const ErrorCode = styled.div(
  props => `
  
    font-size:11rem;
    color: ${props.theme.colors.blue.bgBlueLight};
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
  
  `,
);

export const ErrorCodeDescrption = styled.p(
  props => `
  
    color: ${props.theme.colors.black.base};
    font-size:4.5rem;
    font-family: ${props.theme.font.fontFamily};
    font-weight:bold;
  `,
);

export const ErrorCodeSubDescription = styled.p(
  props => `
  
    color: ${props.theme.colors.black.base};
    font-size:${props.theme.font.large.font24};
    margin-top:${props.theme.spacing.small};
  `,
);

export const NavigationList = styled.ul(
  props => `
   
    font-size:${props.theme.font.large.font18};
    display:flex;
    margin-top:${props.theme.spacing.large.l30};

>li{
    display:flex;
    &:last-child{
        border-right:none;
    }
  }
  `,
);

export const ListItem = styled.a(
  props => `

  padding: 0 ${props.theme.spacing.base};
  border-right:1px solid ${props.theme.colors.grey.lightGrey};
`,
);

export const BodySection = styled.section(
  props => `
    display: flex;
    width: 100%;
    flex-direction: column;
    background-color: ${props.theme.colors.grey.lineGrey};
    position: relative;
    align-items: center;
  `,
);
